import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import plus from './plus.svg';
import minus from './minus.svg';
import arrowUp from './arrow-up.svg';
import arrowDown from './arrow-down.svg';

interface Props {
  children: JSX.Element | string;
  title: string | JSX.Element;
  symbol?: string;
}

const Accordion: React.FC<Props> = (props: Props): JSX.Element => {
  const [isOpen, setIsOpen] = useState(false);

  const { t } = useTranslation('common');

  const openIcon = props.symbol === 'arrow' ? arrowUp : minus;
  const closedIcon = props.symbol === 'arrow' ? arrowDown : plus;

  return (
    <div className='border-black border-y-1 mt-[-1px] relative'>
      <div
        onClick={() => setIsOpen(!isOpen)}
        className='h-4 py-6 flex items-center cursor-pointer'
      >
        <div className='w-full mr-8 uppercase font-rukaNeue'>{props.title}</div>
        <img
          src={isOpen ? openIcon : closedIcon}
          alt={(isOpen ? t('Accordion open') : t('Accordion closed')) ?? ''}
          className='absolute right-0'
        />
      </div>
      {isOpen && <div className='my-4'>{props.children}</div>}
    </div>
  );
};

export default Accordion;
